import { useEffect, useState, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { cmsService } from '../../../../services/homii-services';

import { buildingDomain, roomTypesDomain } from '../../../../domain';

import { useCityById } from '../../../../domain/city/city.domain';

import CityMainSection from '../../../../components/play-page-components/city-main-section.component';
import AboutCitySection from '../../../../components/play-page-components/about-city-section.component';
import LazyFeaturedSpaces from '../../../../components/featured-spaces/lazy-featured-spaces.component';
import BuildingCarousel from '../../../../components/building-carousel/building-carousel.component';
import BlogSection from '../../../../components/home-page-components/blog-section.component';

import SearchSection from '../../../../components/play-page-components/search-section.component';

import FeaturedCities from '../../../../components/play-page-components/featured-cities.component';

import { Layout, Footer, MetaData } from '../../../../components/shared';

const CityDetailsPage = (props) => {
   
    const { data, cityId, cityName } = props;

    const { data: selectedCity } = useCityById(cityId); 

    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const aboutAllCities = _.get(data, 'acf.about_per_city');
    const searchTitle = _.get(data, 'acf.search_section_title');
    const searchParagraph = _.get(data, 'acf.search_section_paragraph');

    const [buildings, setBuildings] = useState([]);

    const [roomTypings, setRoomTypes] = useState([]);

    const allRoomTypes = useMemo(() => _.map(roomTypings, (roomType) => roomType), [roomTypings]);

    useEffect(() => {

        if (!selectedCity) return;

        const asyncSearch = async () => {

            const fetchedBuildings = await buildingDomain.fetchBuildingsByCityId(cityId);
            setBuildings(fetchedBuildings);

            const rooms = await roomTypesDomain.fetchAvailabilityForCity(_.get(selectedCity, 'id'));
            setRoomTypes(rooms);
        };        

        asyncSearch();

    }, [cityId, selectedCity]);    

    return (

        <Layout>

            <MetaData title={seoTitle} desc={seoMetaDesc} />

            <CityMainSection cityName={cityName} data={aboutAllCities} />

            <AboutCitySection data={aboutAllCities} cityName={cityName} buildings={buildings} />

            <LazyFeaturedSpaces
                isHome
                title="Popular Spaces"
                selectedCity={selectedCity}
            />

            <div className='container-root container-root-maxWidthLg building-carousel-container building-carousel-container-settings'>

                <BuildingCarousel margintop={150} cityId={cityId} cityName={cityName} buildings={buildings} roomTypes={allRoomTypes} />

            </div>

            <SearchSection title={searchTitle} paragraph={searchParagraph} cityName={cityName} />

            <div className='blog-carousel-wrapper'>

                <div className='container-root container-root-maxWidthLg blog-carousel-container carousel-container-settings'>
                    
                    <BlogSection page={data.page} showAll />

                </div>

            </div>

            <FeaturedCities cityName={cityName} />

            <Footer />

        </Layout>
    );
};

export default CityDetailsPage;

export const getServerSideProps = async ({ params }) => {
    const { cityId, cityName } = params;
    const data = await cmsService.RetrieveWordPressPage('city-details');
    return {
        props: {
            data,            
            cityId,
            cityName
        }
    };
};

CityDetailsPage.propTypes = {
    data: PropTypes.object,
};

